import { globalStyles } from './style';
import Accordion from './components/accordion';
import AccordionTimeline from './components/accordion-timeline';
import Alert from './components/alert';
import Avatar from './components/avatar';
import Badge from './components/badge';
import Button from './components/button';
import Card from './components/card';
import Descriptions from './components/descriptions';
import Empty from './components/empty';
import FileUpload from './components/file-upload';
import Menu from './components/menu';
import Modal from './components/modal';
import Pagination from './components/pagination';
import Popover from './components/popover';
import Progress from './components/progress';
import RadioGroup from './components/radio-group';
import Result from './components/result';
import SearchBox from './components/searchbox';
import Select from './components/select';
import Shimmer from './components/shimmer';
import Spin from './components/spin';
import Steps from './components/steps';
import SummaryCard from './components/summary-card';
import Tabs from './components/tabs';
import Timeline from './components/timeline';
import { StickyProgress } from './components/sticky-progress';
import { AppThemeConstants } from '../utils';
import { extendTheme, withDefaultColorScheme } from '@chakra-ui/react';

const config = {
  initialColorMode: AppThemeConstants.MODE,
  useSystemColorMode: false,
};
const overrides = {
  components: {
    Accordion: Accordion,
    AccordionTimeline: AccordionTimeline,
    Alert: Alert,
    Avatar: Avatar,
    Badge: Badge,
    Button: Button,
    Card: Card,
    Descriptions: Descriptions,
    Empty: Empty,
    FileUpload: FileUpload,
    Menu: Menu,
    Modal: Modal,
    Pagination: Pagination,
    Popover: Popover,
    Progress: Progress,
    RadioGroup: RadioGroup,
    Result: Result,
    SearchBox: SearchBox,
    Select: Select,
    Shimmer: Shimmer,
    Spin: Spin,
    Steps: Steps,
    SummaryCard: SummaryCard,
    Tabs: Tabs,
    Timeline: Timeline,
    StickyProgress: StickyProgress,
  },
};

export const theme = extendTheme(
  globalStyles,
  { config },
  overrides,
  withDefaultColorScheme({
    colorScheme: AppThemeConstants.PRIMARY_COLOR,
    components: [
      'Accordion',
      'AccordionTimeline',
      'Alert',
      'Avatar',
      'Badge',
      'Button',
      'Card',
      'Descriptions',
      'Empty',
      'FileUpload',
      'Menu',
      'Modal',
      'Pagination',
      'Popover',
      'Progress',
      'RadioGroup',
      'Result',
      'SearchBox',
      'Select',
      'Shimmer',
      'Spin',
      'Steps',
      'SummaryCard',
      'Tabs',
      'Timeline',
      'StickyProgress',
    ],
  }),
);
